
const AnnouncementTypes = {
    setAnnouncementList: 'SET_ANNOUCEMENT_LIST',
    hideAnnouncement: 'HIDE_ANNOUCEMENT',
};

export default AnnouncementTypes;